import { render, staticRenderFns } from "./Vincular.vue?vue&type=template&id=37d60e7f&scoped=true"
import script from "./Vincular.vue?vue&type=script&lang=js"
export * from "./Vincular.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=37d60e7f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d60e7f",
  null
  
)

export default component.exports